document.addEventListener('DOMContentLoaded', function() {
    function initColorSwatches(){
        
        const colorWrappers = document.querySelectorAll('[data-color-swatches]');       
        colorWrappers?.forEach(wrapper => {
        // console.log(wrapper,2222);
            const list = wrapper.querySelector('.product-card__colors-list');
            
            function checkScroll() {
                const isAtEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
                wrapper.classList.toggle('hide-arrow', isAtEnd);
            }

            wrapper.addEventListener('click', function(e) {
                const rect = wrapper.getBoundingClientRect();
                const clickX = e.clientX - rect.left;
                
                if (clickX > rect.width - 24) {
                    list.scrollBy({
                        left: 64,
                        behavior: 'smooth'
                    });
                }
            });

            list.addEventListener('scroll', checkScroll);
            window.addEventListener('load', checkScroll);
            window.addEventListener('resize', checkScroll);
            
            checkScroll();
        });
    }


    initColorSwatches();
    window.initColorSwatches = initColorSwatches;


    function initBlogScroll(){
        
        const bannerSwatches = document.querySelectorAll('[data-banner-swatches]');       
        bannerSwatches?.forEach(wrapper => {
        // console.log(wrapper,2222);
            const list = wrapper.querySelector('.blog-filter-list');
            
            function checkScroll() {
                console.log(list,2222);
                const isAtEnd = list.scrollLeft + list.clientWidth >= list.scrollWidth - 1;
                wrapper.classList.toggle('hide-arrow', isAtEnd);
            }

            wrapper.addEventListener('click', function(e) {
                const rect = wrapper.getBoundingClientRect();
                const clickX = e.clientX - rect.left;
                
                if (clickX > rect.width - 24) {
                    list.scrollBy({
                        left: 64,
                        behavior: 'smooth'
                    });
                }
            });

            list.addEventListener('scroll', checkScroll);
            window.addEventListener('load', checkScroll);
            window.addEventListener('resize', checkScroll);
            
            checkScroll();
        });
    }


    initBlogScroll();

    function initMenuPromotionSlider() {
        const sliders = document.querySelectorAll('.menu-promotion-products-slider');
        sliders.forEach(slider => {
            if (slider && typeof Swiper !== 'undefined') {
            new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
                },
                navigation: {
                nextEl: slider.querySelector('.menu-promotion-products-slider-button-next'),
                prevEl: slider.querySelector('.menu-promotion-products-slider-button-prev'),
                },
                breakpoints: {
                640: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                1024: {
                    slidesPerView: 1,
                    spaceBetween: 40,
                },
                }
            });
            }
        });
    }

    initMenuPromotionSlider();

    // Add to global scope for re-initialization if needed
    window.initSwiper = function() {
        initMenuPromotionSlider();
    };

    fetch(`https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=61e1b8b8b79f07a2e86a8d44&locale=${window.Shopify.locale}-${window.Shopify.country}`)
    .then(response => response.json())
    .then(response => {
        document.querySelectorAll('.trustCount').forEach(el => el.innerHTML = response.businessUnit.numberOfReviews.total);
        document.querySelectorAll('.trustStar').forEach(el => el.innerHTML = response.businessUnit.trustScore);
        
    })


    // Initialize Gorgias chat and hide default button
    function initGorgiasChat() {
        var initGorgiasChatPromise = (window.GorgiasChat) 
            ? window.GorgiasChat.init() 
            : new Promise(function (resolve) { 
                window.addEventListener('gorgias-widget-loaded', function () { resolve(); });
            });

        initGorgiasChatPromise.then(function () { 
            // Hide the default Gorgias chat button since we use custom buttons
            var timer = setInterval(function () { 
                var gorgiasContainer = document.querySelector('#gorgias-chat-container');
                if (!gorgiasContainer) {
                    return;
                }

                var chatButtonIframe = gorgiasContainer.querySelector('#chat-button');
                if (!chatButtonIframe || !chatButtonIframe.contentWindow || !chatButtonIframe.contentWindow.document) {
                    return;
                }

                var chatButtonDoc = chatButtonIframe.contentWindow.document;
                if (!chatButtonDoc.body || !chatButtonDoc.body.querySelector('#gorgias-chat-messenger-button')) {
                    return;
                }

                clearInterval(timer);

                // Hide the default Gorgias button completely
                var defaultButton = chatButtonDoc.body.querySelector('#gorgias-chat-messenger-button');
                if (defaultButton) {
                    defaultButton.style.display = 'none';
                }

                // Also hide the iframe container
                if (chatButtonIframe) {
                    chatButtonIframe.style.display = 'none';
                }

                // Setup toggle functionality for custom buttons
                setupGorgiasToggleButtons();
                
                // Setup custom close button
                setupGorgiasCloseButton();
            }, 50);
        });
    }

    // Setup custom close button for Gorgias chat
    function setupGorgiasCloseButton() {
        var closeButton = document.getElementById('gorgias-custom-close-btn');
        if (!closeButton) {
            console.log('Gorgias close button not found in DOM');
            return;
        }
        
        console.log('Gorgias close button found, setting up...');

        // Initially hide the close button
        closeButton.style.display = 'none';

        // Wait for GorgiasChat to be available
        var initCloseButton = function() {
            if (!isGorgiasAvailable()) {
                closeButton.style.display = 'none';
                return;
            }

            if (window.GorgiasChat && window.GorgiasChat.on) {
                console.log('GorgiasChat API available, setting up event listeners');
                // Show close button when chat opens
                window.GorgiasChat.on('widget:opened', function() {
                    console.log('Chat opened, showing close button');
                    closeButton.setAttribute('data-gorgias', 'close');
                    closeButton.style.display = 'flex';
                });

                // Hide close button when chat closes
                window.GorgiasChat.on('widget:closed', function() {
                    console.log('Chat closed, hiding close button');
                    closeButton.setAttribute('data-gorgias', 'close');
                    closeButton.style.display = 'none';
                });
            } else {
                console.log('GorgiasChat API not yet available, using fallback method');
                // Fallback: monitor chat window visibility if events aren't available
                var checkChatState = setInterval(function() {
                    if (window.GorgiasChat && window.GorgiasChat.on) {
                        clearInterval(checkChatState);
                        // Events are now available, use them
                        window.GorgiasChat.on('widget:opened', function() {
                            closeButton.style.display = 'flex';
                        });
                        window.GorgiasChat.on('widget:closed', function() {
                            closeButton.style.display = 'none';
                        });
                        return;
                    }

                    // Check if chat window is visible
                    var chatWindow = document.querySelector('#gorgias-chat-container #chat-window');
                    if (chatWindow) {
                        var computedStyle = window.getComputedStyle(chatWindow);
                        var isVisible = computedStyle.display !== 'none' && 
                                       computedStyle.visibility !== 'hidden' && 
                                       computedStyle.opacity !== '0';
                        closeButton.style.display = isVisible ? 'flex' : 'none';
                    } else {
                        closeButton.style.display = 'none';
                    }
                }, 100);

                // Stop checking after 10 seconds
                setTimeout(function() {
                    clearInterval(checkChatState);
                }, 10000);
            }
        };

        // Try to initialize immediately
        initCloseButton();

        // Also try after a delay in case GorgiasChat loads later
        setTimeout(initCloseButton, 1000);

        // Close chat when button is clicked (using data-attribute)
        closeButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            if (isGorgiasAvailable() && window.GorgiasChat.close) {
                window.GorgiasChat.close();
            }
        });
    }

    // Check if Gorgias is available and initialized
    function isGorgiasAvailable() {
        return typeof window.GorgiasChat !== 'undefined' && 
               window.GorgiasChat && 
               (window.GorgiasChat.open || window.GorgiasChat.init);
    }

    // Show/hide buttons based on Gorgias availability
    function toggleGorgiasButtonsVisibility(show) {
        var buttons = document.querySelectorAll('[data-gorgias="open"]');
        
        buttons.forEach(function(button) {
            if (show) {
                // Show button - use appropriate display based on button type
                if (button.classList.contains('header__wrapper-gorgias-btn-mob')) {
                    // Mobile button - check if it should be visible on mobile
                    button.style.display = '';
                } else {
                    // Desktop button
                    button.style.display = '';
                }
            } else {
                // Hide button
                button.style.display = 'none';
            }
        });
    }

    // Setup toggle functionality for Gorgias chat buttons
    function setupGorgiasToggleButtons() {
        // Function to check if chat is currently open
        function isChatOpen() {
            var chatWindow = document.querySelector('#gorgias-chat-container #chat-window');
            if (!chatWindow) {
                return false;
            }
            // Check multiple ways to determine if chat is open
            var computedStyle = window.getComputedStyle(chatWindow);
            var isVisible = computedStyle.display !== 'none' && 
                           computedStyle.visibility !== 'hidden' && 
                           computedStyle.opacity !== '0';
            return isVisible;
        }

        // Function to toggle chat
        function toggleGorgiasChat() {
            if (!isGorgiasAvailable()) {
                return;
            }

            var currentlyOpen = isChatOpen();

            if (currentlyOpen) {
                // Chat is open, close it
                if (window.GorgiasChat.close) {
                    window.GorgiasChat.close();
                }
            } else {
                // Chat is closed, open it
                if (window.GorgiasChat.open) {
                    window.GorgiasChat.open();
                }
            }
        }

        // Setup buttons with data-attributes
        var buttons = document.querySelectorAll('[data-gorgias="open"]');
        buttons.forEach(function(button) {
            // Remove existing onclick
            button.onclick = null;
            
            button.addEventListener('click', function(e) {
                e.preventDefault();
                toggleGorgiasChat();
            });
        });

        // Check Gorgias availability and show/hide buttons
        var checkAvailability = function() {
            if (isGorgiasAvailable()) {
                toggleGorgiasButtonsVisibility(true);
            } else {
                toggleGorgiasButtonsVisibility(false);
            }
        };

        // Check immediately
        checkAvailability();

        // Check periodically until Gorgias is available
        var availabilityCheck = setInterval(function() {
            if (isGorgiasAvailable()) {
                toggleGorgiasButtonsVisibility(true);
                clearInterval(availabilityCheck);
            }
        }, 500);

        // Stop checking after 10 seconds
        setTimeout(function() {
            clearInterval(availabilityCheck);
            checkAvailability(); // Final check
        }, 10000);
    }

    // Initialize Gorgias chat
    initGorgiasChat();
    
    // Also setup close button immediately (will wait for GorgiasChat if needed)
    setupGorgiasCloseButton();
    
});

